import Phaser from "phaser";

/**
 * Attaches camera panning and zooming controls to a Phaser scene.
 * @param {Phaser.Scene} scene The scene to attach the controls to.
 * @param {{width: number, height: number}} boardSize The dimensions of the game board.
 */
export default function attachCameraControls(scene, boardSize) {
    const cam = scene.cameras.main;
    cam.setBounds(0, 0, boardSize.width, boardSize.height);

    const minZoom = 1;
    const maxZoom = 3;
    const zoomIntensity = 0.1;
	// 2d vector storing start position of camera drag
    let dragStart = new Phaser.Math.Vector2();

    // ===== Pan Controls =====
    scene.input.on(Phaser.Input.Events.POINTER_DOWN, (pointer) => {
        // left click
		if (pointer.button === 0) {
            dragStart.set(pointer.x, pointer.y);
        }
    });

	// on click hold and move
    scene.input.on(Phaser.Input.Events.POINTER_MOVE, (pointer) => {
        if (pointer.isDown) {
            // Move the camera by the amount the pointer has moved.
            const dx = pointer.x - dragStart.x;
            const dy = pointer.y - dragStart.y;

            // Divide by zoom for consistent speed
            cam.scrollX -= dx / cam.zoom;
            cam.scrollY -= dy / cam.zoom;

            // Update the starting drag position for the next frame.
            dragStart.set(pointer.x, pointer.y);
        }
    });

    // ===== Zoom =====
    scene.input.on(Phaser.Input.Events.WHEEL, (pointer, gameObjects, deltaX, deltaY, deltaZ) => {
		let newZoom;
        
        // -deltaY means scrolling up (zoom in).
        // +deltaY means scrolling down (zoom out).
        if (deltaY < 0) {
            newZoom = cam.zoom * (1 + zoomIntensity);
        } else {
            newZoom = cam.zoom * (1 - zoomIntensity);
        }
        // clamp zoom value to min/max
        newZoom = Phaser.Math.Clamp(newZoom, minZoom, maxZoom);

		// Zooming while keeping the current cursor location centered
        // Get the world point under the pointer before  zoom.
        const worldPoint = cam.getWorldPoint(pointer.x, pointer.y);
        cam.setZoom(newZoom); // apply zoom
        // calculate the new world point and adjust camera
        const newWorldPoint = cam.getWorldPoint(pointer.x, pointer.y);
        cam.scrollX += worldPoint.x - newWorldPoint.x;
        cam.scrollY += worldPoint.y - newWorldPoint.y;
    });
}